/* Copyright (c) 2026 Hyegro Pty Ltd. All rights reserved. */

/**
 * /account/360/:id. In v2 the account page itself is the Account 360, so the
 * old view redirects there; classic keeps Customer360View as it was. A
 * wrapper rather than an early return inside Customer360View, which would
 * skip that component's hooks.
 */

import { Navigate, useParams } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import Customer360View from "./Customer360View";

export default function Customer360Route() {
  const { id } = useParams();
  const isV2 = useTheme()?.pearlUi === "v2";
  if (isV2) return <Navigate to={`/accounts/${id}`} replace />;
  return <Customer360View />;
}
